import { useQuery } from "@tanstack/react-query";
import { Flame } from "@phosphor-icons/react";
import { VideoCard } from "@/components/VideoCard";
import { fetchNewThisWeek } from "@/lib/api";

export const NewThisWeekRow = () => {
  const { data } = useQuery({
    queryKey: ["new-this-week"],
    queryFn: () => fetchNewThisWeek(15),
    staleTime: 5 * 60 * 1000,
  });

  const videos = data?.videos || [];
  if (videos.length === 0) return null;

  return (
    <section className="mb-12" data-testid="new-this-week-row">
      <div className="flex flex-wrap items-center gap-3 mb-5">
        <h2 className="font-serif text-2xl sm:text-3xl tracking-tight text-[#EDEDED]">New This Week</h2>
        <span
          data-testid="fresh-badge"
          className="flex items-center gap-1.5 bg-gradient-to-r from-amber to-crimson text-black font-mono text-[10px] font-black uppercase tracking-[0.15em] px-3 py-1 shadow-[0_0_18px_rgba(255,176,0,0.5)]"
        >
          <Flame size={13} weight="fill" /> 7-Day Fresh
        </span>
      </div>

      <div className="flex gap-4 rv-snap-row overflow-x-auto hide-scrollbar pb-2 -mx-1 px-1">
        {videos.map((v, i) => (
          <div key={v.video_id} className="rv-row-card w-[280px] sm:w-[320px] shrink-0">
            <VideoCard video={v} index={i} datePill />
          </div>
        ))}
      </div>
    </section>
  );
};
